export type AfvigelseValg = "skema" | "timer" | "ekstra";

/** HTML number-inputs kræver punktum i DOM-værdien. */
function minutterTilInput(minutter: number): string {
  return String(minutter / 60);
}

/**
 * "Andet timetal" er dagens samlede tid. "Ekstra tid" er kun tillægget til
 * skemaet. Nye valg starter derfor på skematiden eller nul, mens en gemt
 * afvigelse får sin faktiske værdi tilbage.
 */
export function afvigelseInputVaerdi(
  valg: Exclude<AfvigelseValg, "skema">,
  oprindeligType: "timer" | "ekstra" | "fravaer" | null | undefined,
  planlagtMinutter: number,
  nettoMinutter: number,
): string {
  if (valg === "timer") {
    return minutterTilInput(
      oprindeligType === "timer" ? nettoMinutter : planlagtMinutter,
    );
  }
  return minutterTilInput(
    oprindeligType === "ekstra"
      ? Math.max(0, nettoMinutter - planlagtMinutter)
      : 0,
  );
}

export function afvigelseInputLabel(valg: AfvigelseValg): string {
  return valg === "ekstra" ? "Ekstra timer" : "Timer i alt";
}
